var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3261 9.00617C16.5296 8.8318 16.6313 8.74461 16.6686 8.64086C16.7013 8.5498 16.7013 8.4502 16.6686 8.35914C16.6313 8.25539 16.5296 8.1682 16.3261 7.99383L9.26719 1.94331C8.917 1.64315 8.74191 1.49306 8.59367 1.48939C8.46483 1.48619 8.34177 1.54279 8.26035 1.64269C8.16667 1.75764 8.16667 1.98825 8.16667 2.44948V6.02886C6.38777 6.34007 4.75966 7.24146 3.54976 8.59489C2.23069 10.0704 1.50103 11.98 1.5 13.9591V14.4691C2.37445 13.4157 3.46626 12.5638 4.70063 11.9716C5.78891 11.4495 6.96535 11.1403 8.16667 11.0588V14.5505C8.16667 15.0117 8.16667 15.2424 8.26035 15.3573C8.34177 15.4572 8.46483 15.5138 8.59367 15.5106C8.74191 15.5069 8.917 15.3569 9.26719 15.0567L16.3261 9.00617Z",
    stroke: "#5C667B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.6fe4a25f23decf81c435eec5cd16a49b.svg";
export { ForwardRef as ReactComponent };